import { render, staticRenderFns } from "./Gallery13.vue?vue&type=template&id=05f3d3ba&scoped=true&"
import script from "./Gallery13.vue?vue&type=script&lang=js&"
export * from "./Gallery13.vue?vue&type=script&lang=js&"
import style0 from "./Gallery13.vue?vue&type=style&index=0&id=05f3d3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f3d3ba",
  null
  
)

export default component.exports